import { mapState, mapGetters, mapActions } from 'vuex'

export const agentRegistrationComputed = {
  ...mapState('agentRegistration', {
    loading: (state) => state.loading,
  }),
  ...mapGetters('agentRegistration', ['getStatus', 'getErrors']),
}

export const agentRegistrationMethods = mapActions('agentRegistration', [
  'registrationAgent',
  'resetRegistrationAgent',
])
